import react, { Component } from 'react';
import { Row, Col } from 'reactstrap'
import { useHistory } from "react-router-dom";

import '../Styles/ParsicHeader.css';
// import 'bootstrap/dist/css/bootstrap.css';

const ParsicHeader = (props) => {

    const goToHomePage = () => {
        window.location.href = "http://www.home.pws.ir";
    }

    return (
        <div className="ParsicHeaderBox">
            <Row>
                <Col className="navbar-menu">
                    {/* <a href="/contact" className="navbar-link">ارتباط با ما</a> */}
                    {/* <a href="/about" className="navbar-link">درباره ما</a> */}
                    <a onClick={goToHomePage} title="www.home.pws.ir" className="navbar-link">محصولات</a>
                    <a onClick={goToHomePage} title="www.home.pws.ir" className="navbar-link">خانه</a>
                </Col>
                <Col className="navbar-info">
                    <div>
                        <label className="nav-company-title"><h1 className="nav-company-title">پارسی پل خودران</h1></label>
                        <img className="img-fluid shadow nav-company-logo" src="./Assets/logo.png"></img>
                    </div>
                </Col>
            </Row>
        </div>
    );

}

export default ParsicHeader;